import { isRejectedWithValue } from '@reduxjs/toolkit';
import { createListenerMiddleware } from '@rtk-incubator/action-listener-middleware';
// import { setErors } from 'src/store/error';
// import { PayloadWithError } from './error-handler';

const listenerMiddleware = createListenerMiddleware();

listenerMiddleware.startListening({
  matcher: isRejectedWithValue,
  effect: async (action, listenerApi) => {
    // const { error } = action.payload as PayloadWithError;
    // listenerApi.dispatch(setErors({ type: action.type, errors: error }));
  },
});

export default listenerMiddleware;
